import { render, staticRenderFns } from "./BayonnomaPechat.vue?vue&type=template&id=f177bc5a"
import script from "./BayonnomaPechat.vue?vue&type=script&lang=js"
export * from "./BayonnomaPechat.vue?vue&type=script&lang=js"
import style0 from "./BayonnomaPechat.vue?vue&type=style&index=0&id=f177bc5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports